// ============================================================
// CareChargeRoleAssignModal.jsx  (role-model expansion Push 1, 2026-07-13)
// Modal form to assign / change a user's CareCharge module role.
// Clone of CarePeopleRoleAssignModal MINUS the tier select (finance has a
// single access level — locked F1). Reuses the cp-role-modal styling.
//
//   - Radio: Finance (billing operations) / Finance Manager (operations +
//     CareCharge settings — the module-config tier, ratified 2026-07-12).
//   - Inline error (from the parent's failed submit) keeps the modal open
//     so the admin can correct + retry.
// ============================================================

import React, { useEffect, useState } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import Modal from './Modal';
import './CarePeopleRoleAssignModal.css';

const ROLE_OPTIONS = [
  { value: 'finance', label: 'Finance', help: 'Billing operations (invoices, payments, revenue assurance).' },
  { value: 'finance_manager', label: 'Finance Manager', help: 'Billing operations + CareCharge settings (the provider billing profile).' },
];

export default function CareChargeRoleAssignModal({
  isOpen,
  onClose,
  onSubmit,
  submitting = false,
  errorMessage = null,
  initialRole = 'finance',
}) {
  const [role, setRole] = useState(initialRole);

  // Reset to the seeded value each time the modal opens.
  useEffect(() => {
    if (isOpen) setRole(initialRole);
  }, [isOpen, initialRole]);

  function handleSubmit(e) {
    e.preventDefault();
    if (submitting) return;
    onSubmit({ careChargeRole: role });
  }

  const selected = ROLE_OPTIONS.find((o) => o.value === role);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Assign CareCharge role" closeDisabled={submitting}>
      <form className="cp-role-modal" onSubmit={handleSubmit}>
        <fieldset className="cp-role-modal__fieldset" disabled={submitting}>
          <legend className="cp-role-modal__legend">Role</legend>
          {ROLE_OPTIONS.map((o) => (
            <label className="cp-role-modal__radio" key={o.value}>
              <input
                type="radio"
                name="careChargeRole"
                value={o.value}
                checked={role === o.value}
                onChange={() => setRole(o.value)}
              />
              <span>{o.label}</span>
            </label>
          ))}
          {selected && <span className="cp-role-modal__help">{selected.help}</span>}
        </fieldset>

        {errorMessage && (
          <div className="cp-role-modal__error" role="alert">
            <AlertCircle size={14} />
            <span>{errorMessage}</span>
          </div>
        )}

        <div className="cp-role-modal__actions">
          <button type="button" className="cp-role-modal__cancel" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button type="submit" className="cp-role-modal__submit" disabled={submitting}>
            {submitting && <Loader2 size={14} className="cp-role-modal__spinner" />}
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
}
